import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertErrorHandler implements ErrorHandler {
  handleError(error: Error | any): void {
    console.log('AlertErrorHandler caught an error:', error);
    
    // Safely access error properties
    if (error && typeof error === 'object' && error.name && 
        typeof error.name === 'string' && 
        error.name.toLowerCase() === 'invaid_currency_code') {
      alert(error.message);
      window.location.reload();
    }
    
    // Don't swallow other errors - let them propagate to console
    console.error(error);
  }
}
